import { render } from "./AuthSidebar.vue?vue&type=template&id=31c2d94f&ts=true"
import script from "./AuthSidebar.vue?vue&type=script&lang=ts"
export * from "./AuthSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__